/**
 * 港股页面
 */
import React, { useEffect } from "react"
import "./index.less"
import { StockHeader } from "../../shared/stock_header"
import { quotedata } from "../../shared/quotedata"
import { StockInfoTabs } from "../../shared/stock_info_tabs"
import { ChartTab } from "../../shared/chart_tab"
import { store } from "./store"
import { OpenInApp } from "../../shared/open_in_app"
import { GoTop } from "../../shared/go_top"
import { CommonFooter } from "../../shared/common_footer"
import { StockFixedFooter } from "../../shared/stock_fixed_footer"
import { AdvertiseTop } from "../../shared/advertise_top"
import { HKBasicInfo } from "./basic_info"
import { getPageType, getStockErrorTradeStatus, getStockSubType, PageType, StockSubType } from "../../shared/pagetype"
import { Observer } from "mobx-react-lite"
import { getMarketSource } from "../../../modules/quote/web"
import { TradeList } from "../../shared/hk_trade_list"
import { HAPrice } from "./ha_price"
import { QuoteTradeRecord } from "../../shared/utils"
import { DoubleCounter } from "./double_counter"

export function Page_HK(props: { quotedata: quotedata }) {
  let pagetype = getPageType()
  let stocksubtype = getStockSubType()
  let _market = getMarketSource(props.quotedata.quotecode)
  let trade_status = getStockErrorTradeStatus()

  useEffect(() => {
    let check =  /^(http|https):\/\/[\w\.-]+\.eastmoney.com\//
    if (!check.test(document.referrer) && document.referrer != "") {
      let gotoUrl = `https://wap.eastmoney.com/quote/hk.html?${encodeURIComponent(`hkruletip=1&backurl=${window.location.href}`)}`
      if(check.test(gotoUrl)){
        window.location.href = gotoUrl
      }
    }
  }, [])
  
  return (
    <>
      <AdvertiseTop />
      <div className="stock-detail">
        <WrapStockHeader quotedata={props.quotedata} pagetype={pagetype} />
        <HKBasicInfo stocksubtype={stocksubtype} quotedata={props.quotedata} pagetype={pagetype} trade_status={trade_status}/>
        <HAPrice pagetype={pagetype} />
        <WrapDoubleCounter pagetype={pagetype} />
        <WrapCharts quotedata={props.quotedata} pagetype={pagetype} stocksubtype={stocksubtype} />
        <WrapTradeList quotedata={props.quotedata} />
        <StockInfoTabs showTabs={["股吧", "资讯", "公告", "研报", "财务", "必读"]} quotedata={props.quotedata} pagetype={pagetype} _market={_market} />
      </div>
      <OpenInApp quotedata={props.quotedata} type={"page"} />
      <GoTop />
      <CommonFooter quotedata={props.quotedata} hide_fix_bottom={false} />
      <StockFixedFooter quotedata={props.quotedata} pagetype={pagetype} />
    </>
  )
}

function WrapStockHeader(props: { quotedata: quotedata; pagetype: PageType }) {
  return <Observer>{() => <StockHeader quotedata={props.quotedata} detail_data={store.StockDetail} pagetype={props.pagetype} />}</Observer>
}

function WrapCharts(props: { quotedata: quotedata; pagetype: PageType; stocksubtype: StockSubType }) {
  return <Observer>{() => <>{store.StockDetail && <ChartTab quotedata={props.quotedata} pagetype={props.pagetype} stocksubtype={props.stocksubtype} />}</>}</Observer>
}

function WrapTradeList(props: { quotedata: quotedata }) {
  return <Observer>{() => <>{store.QuoteTradeType == QuoteTradeRecord.十档行情 && <TradeList quotedata={props.quotedata} />}</>}</Observer>
}

function WrapDoubleCounter(props: { pagetype: PageType }) {
  return <Observer>{() => <>{store.StockDetail && <DoubleCounter pagetype={props.pagetype} />}</>}</Observer>
}
